<div class="border-mimic">
    <div style="margin-top:4px;margin-left:4px;margin-right:4px;margin-bottom:4px;height:100%;width:100%;background-color:white;">
        <div style="height:125px;">
            <div style="margin-top:30px;margin-left:100px;">
            <div class="row text-center">
                <div class="col-12">
                <span><button mat-flat-button (click)="onFinalizeInvoice()">Finalize</button></span>
                <span><button mat-flat-button  [mat-dialog-close]>Modify</button></span>
                <span><button mat-flat-button [mat-dialog-close]>Delete</button></span>
                </div>
            </div>
            </div>
        </div>
        <div style="margin-left:10px;margin-right:10px;position:relative;top:-60px;">
        <!-- <embed src="../../../../assets/reports/MI04258052516939.pdf" width="100%" height="750px" 
    type="application/pdf">
        </div> -->
       <app-manual-invoice-primary></app-manual-invoice-primary>
    </div>
</div>


